import {TooltipProvider} from "@src/ui/views/tooltip";
import * as React from "react";
import {Provider as ReduxStoreProvider} from "react-redux";
import {AppRoutes} from "@src/integrations/react-router/routes";
import {appStore} from "@src/integrations/redux/redux-store";
import {ThemeProvider} from "@src/features/settings/contexts/theme-provider";
import 'leaflet/dist/leaflet.css'


export function App() {
	return (
		<ReduxStoreProvider store={appStore}>
			<ThemeProvider defaultTheme="system">
				<TooltipProvider>
					<AppRoutes />
				</TooltipProvider>
			</ThemeProvider>
		</ReduxStoreProvider>
	);
}
